<template>
  <BasePopup
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
    :deleteIcon="deleteIcon"
    :deleteButtonLabel="deleteButtonLabel"
    :deleteTitle="deleteTitle"
    :deleteConfirmButtonLabel="deleteConfirmButtonLabel"
    :readOnly="readOnly"
  >
    <p> Você tem certeza que deseja concluir a venda ?</p>
  </BasePopup>
</template>

<script>
import gql from 'graphql-tag';
// import BaseDelete from "@shared_components/base_delete.vue";
import BasePopup from '../../shared/base_popup.vue';

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {    
    BasePopup: BasePopup,
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    deleteIcon: {
      type: String,
      default: "mdi-lock-outline",
    },
    deleteButtonLabel: {
      type: String,
      default: function() {
        return "Faturar venda";
      }
    },
    deleteTitle: {
      type: String,
      default: function() {
        return "Faturar Venda"
      }
    },
    deleteConfirmButtonLabel: {
      type: String,
      default: "Faturar"
    },
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(sale) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: CLOSE_SALE_MUTATION,
            variables: {
              id: sale.id,
            }
          })
          .then(response => {
            var errors = response.data.closeSale.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}

const CLOSE_SALE_MUTATION = gql `
  mutation($id: ID!) {
    closeSale(id: $id) {
      cashFlow {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>
